// Social screens' copy in Italian (the Dutch in lib/social/copy.ts is the source), in our own words.
export const socialHubIt = {
  "social.about.section.account": "Account",
  "social.about.sync.title": "Porta con te le tue note",
  "social.about.sync.action": "Accedi",
  "social.about.sync.manage": "Gestisci",
  "social.about.sync.signedInAs": "Accesso come {email}",
  "social.about.sync.unconfirmed":
    "Ora non siamo riusciti a controllare il tuo account; resti connesso e riproviamo tra poco.",
  "social.signin.gate.title": "Accedi per degustare insieme",
  "social.signin.gate.body":
    "Amici, gruppi e degustazioni appartengono a un account. Le note su questo dispositivo restano tue.",
  "social.signin.gate.action": "Accedi",
  "social.about.public.label": "Raggiungibile dai messaggi a «tutti»",
  "social.about.public.hint":
    "Attivalo perché gli amici fuori dai tuoi gruppi possano raggiungerti con un messaggio a «tutti» in una degustazione. Decide solo chi può inviarti messaggi, non se compari nei risultati di ricerca: quello si regola in «Gli altri possono trovarti».",
  "social.about.discoverable.label": "Gli altri possono trovarti",
  "social.about.discoverable.hint":
    "Il tuo nome utente e il tuo nome compaiono nella ricerca degli altri utenti. Disattivalo per non essere trovato.",
  "social.signin.title": "Accedi",
  "social.signin.subtitle": "Scegli come accedere",
  "social.signin.provider.google": "Google",
  "social.signin.provider.microsoft": "Microsoft",
  "social.signin.provider.instagram": "Instagram",
  "social.signin.provider.tiktok": "TikTok",
  "social.signin.provider.pending":
    "Non ancora disponibile: in attesa della verifica del fornitore",
  "social.signin.error.denied": "Accesso annullato o rifiutato.",
  "social.signin.error.generic": "Accesso non riuscito. Riprova.",
  "social.signin.success.title": "Accesso effettuato",
  "social.friends.title": "Amici",
  "social.friends.empty.title": "ancora nessun amico",
  "social.friends.empty.body": "Aggiungi un amico per degustare insieme.",
  "social.friends.empty.action": "Aggiungi amico",
  "social.friends.incoming.title": "Richieste",
  "social.friends.incoming.accept": "Accetta",
  "social.friends.incoming.decline": "Rifiuta",
  "social.friends.outgoing.label": "Richiesta inviata",
  "social.friends.outgoing.cancel": "Annulla la richiesta",
  "social.friends.row.block": "Blocca",
  "social.friends.row.unblock": "Sblocca",
  "social.friends.row.remove": "Rimuovi",
  "social.friends.accepted.toast": "Ora siete amici",
  "social.friends.add.title": "Aggiungi amico",
  "social.friends.add.searchPlaceholder": "Nome o nome utente",
  "social.friends.add.send": "Invia richiesta",
  "social.friends.add.queued": "Parte appena torni online",
  "social.friends.add.sent": "Inviata",
  "social.friends.add.noResults": "Nessun risultato",
  "social.friends.add.action": "Aggiungi",
  "social.friends.search.resultCount": "{n} risultati",
  "social.groups.title": "Gruppi",
  "social.groups.empty.title": "ancora nessun gruppo",
  "social.groups.empty.body": "Crea un gruppo per degustare insieme.",
  "social.groups.empty.action": "Crea gruppo",
  "social.groups.memberCount": "{n} membri",
  "social.groups.role.owner": "proprietario",
  "social.groups.role.admin": "amministratore",
  "social.groups.role.member": "membro",
  "social.groups.create.title": "Crea gruppo",
  "social.groups.create.name": "Nome",
  "social.groups.create.description": "Descrizione (facoltativa)",
  "social.groups.create.confirm": "Crea",
  "social.groups.edit.title": "Modifica gruppo",
  "social.groups.edit.confirm": "Salva",
  "social.groups.avatar.upload": "Scegli una foto",
  "social.groups.avatar.uploading": "Caricamento…",
  "social.groups.avatar.remove": "Rimuovi la foto",
  "social.groups.visibility.label": "Chi può vedere questo gruppo",
  "social.groups.visibility.membersAndInvitees": "Visibile a membri e invitati",
  "social.groups.visibility.membersOnly": "Solo i membri, senza anteprima del link",
  "social.groups.visibility.discoverable": "Visibile nell'elenco dei gruppi",
  "social.groups.directory.entry": "Cerca un gruppo",
  "social.groups.directory.title": "Cerca un gruppo",
  "social.groups.directory.searchPlaceholder": "Nome del gruppo",
  "social.groups.directory.noResults": "Nessun gruppo trovato",
  "social.groups.directory.resultCount": "{n} risultati",
  "social.groups.directory.requestToJoin": "Chiedi di entrare",
  "social.groups.directory.requested": "Richiesta inviata",
  "social.groups.joinRequests.title": "Richieste di ingresso",
  "social.groups.joinRequests.accept": "Accetta",
  "social.groups.joinRequests.decline": "Rifiuta",
  "social.groups.invitePermission.label": "Chi può invitare",
  "social.groups.invitePermission.ownerAdmin": "Solo proprietario e amministratori",
  "social.groups.invitePermission.anyMember": "Qualsiasi membro",
  "social.groups.detail.editAction": "Modifica gruppo",
  "social.groups.detail.removeMember": "Rimuovi",
  "social.groups.detail.leave": "Lascia il gruppo",
  "social.groups.detail.delete": "Elimina il gruppo",
  "social.groups.detail.loadMore": "Mostra altro",
  "social.groups.detail.zeroOwnerLeaveBlocked": "Cedi prima la proprietà, oppure elimina il gruppo",
  "social.groups.invite.title": "Invita",
  "social.groups.invite.noFriends": "Nessun amico da invitare.",
  "social.session.title": "Degustazione",
  "social.session.draft.nameLabel": "Nome",
  "social.session.draft.invite": "Invita",
  "social.session.draft.startNow": "Avvia ora",
  "social.session.scheduled.label": "Prevista per {date}",
  "social.session.action.schedule": "Pianifica",
  "social.session.action.start": "Avvia",
  "social.session.action.cancel": "Annulla",
  "social.session.action.end": "Termina",
  "social.session.status.invited": "invitato",
  "social.session.status.joined": "partecipa",
  "social.session.status.online": "online",
  "social.session.status.offline": "offline",
  "social.session.status.live": "In diretta",
  "social.session.ended.title": "Terminata",
  "social.session.ended.toast": "questa degustazione è terminata",
  "social.session.reconnecting": "Riconnessione…",
  "social.session.presenceCount": "{n} online",
  "social.session.schedule.date": "Data (facoltativa)",
  "social.session.schedule.time": "Ora (facoltativa)",
  "social.session.schedule.invalid": "Scegli una data e un'ora future.",
  "social.session.invite.title": "Invita i partecipanti",
  "social.session.invite.confirm": "Invita",
  "social.session.invite.sourceFriends": "Amici",
  "social.session.invite.sourceGroup": "Gruppo",
  "social.broadcast.composer.title": "Invia un messaggio",
  "social.broadcast.composer.targetFriends": "Amici",
  "social.broadcast.composer.targetGroup": "Gruppo",
  "social.broadcast.composer.targetEveryone": "Tutti in questa degustazione",
  "social.broadcast.composer.textPlaceholder": "Il tuo messaggio…",
  "social.broadcast.composer.send": "Invia",
  "social.broadcast.composer.queued": "Parte appena torni online",
  "social.broadcast.composer.sent": "Inviato",
  "social.broadcast.composer.sentPartial": "Inviato, {n} non consegnati",
  "social.broadcast.panel.title": "Rivolti a te in questa degustazione",
  "social.broadcast.panel.empty": "Ancora niente di rivolto a te in questa degustazione",
  "social.presence.online": "online",
  "social.presence.offline": "offline",
  "social.invite.friends.action": "Invita",
  "social.invite.friends.title": "Invita amici",
  "social.invite.friends.lead":
    "Manda il tuo link personale. Chi lo apre e accede diventa tuo amico.",
  "social.invite.group.title": "Invita in {group}",
  "social.invite.group.lead": "Chi apre il link o digita il codice entra nel gruppo.",
  "social.invite.channel.whatsapp": "WhatsApp",
  "social.invite.channel.email": "E-mail",
  "social.invite.channel.sms": "SMS",
  "social.invite.channel.copy": "Copia il link",
  "social.invite.channel.copied": "Link copiato",
  "social.invite.qr.label": "Codice QR con l'invito",
  "social.invite.code.label": "Oppure dì questo codice",
  "social.invite.code.until": "Valido fino alle {time}",
  "social.invite.status": "Ancora {left} usi su {max}, valido fino al {date}",
  "social.invite.audience.one": "Una persona",
  "social.invite.audience.many": "Fino a 10 persone",
  "social.invite.audience.manyHint": "Con più persone confermi tu ogni richiesta.",
  "social.invite.approval.label": "Approva prima i nuovi membri",
  "social.invite.joined.title": "Chi è entrato",
  "social.invite.revoke": "Revoca il link",
  "social.invite.revoked": "Questo link non funziona più.",
  "social.invite.renew": "Crea un nuovo link",
  "social.invite.landing.title": "Invito",
  "social.invite.landing.friend": "{name} ti invita a degustare insieme.",
  "social.invite.landing.group": "{name} ti invita in {group}.",
  "social.invite.landing.groupHidden": "{name} ti invita in un gruppo.",
  "social.invite.landing.approval": "Un amministratore approva la tua richiesta.",
  "social.invite.landing.expires": "Valido fino al {date}",
  "social.invite.landing.accept": "Accetta",
  "social.invite.landing.decline": "No, grazie",
  "social.invite.landing.signIn": "Accedi per accettare",
  "social.invite.landing.gone.title": "Questo invito non funziona più",
  "social.invite.landing.gone.body": "Chiedi un nuovo link o codice.",
  "social.invite.landing.none.title": "Nessun invito trovato",
  "social.invite.landing.none.body": "Riapri il link, oppure digita il codice.",
  "social.invite.outcome.friends": "Ora siete amici",
  "social.invite.outcome.requested": "Richiesta inviata. {name} la confermerà.",
  "social.invite.outcome.joined": "Sei entrato nel gruppo",
  "social.invite.outcome.joinRequested": "Richiesta inviata. Un amministratore la approverà.",
  "social.invite.outcome.toFriends": "Vai agli amici",
  "social.invite.outcome.toGroup": "Vai al gruppo",
  "social.code.action": "Hai un codice?",
  "social.code.title": "Inserisci un codice",
  "social.code.hint": "Tre parole per un invito, sei per una degustazione.",
  "social.code.placeholder": "es. leaf lime loft",
  "social.code.submit": "Continua",
  "social.code.invalid": "Questo non è un codice. Ricontrolla le parole.",
  "social.samen.title": "Insieme",
  "social.samen.badge": "{label}, {count} nuovi",
  "social.samen.announce": "{count} nuovi in Insieme",
  "social.samen.profile": "Il tuo profilo",
  "social.samen.lead": "I tuoi amici, i tuoi gruppi e ciò che ti aspetta.",
  "social.inbox.title": "Posta",
  "social.inbox.tab.received": "Ricevuti",
  "social.inbox.tab.sent": "Inviati",
  "social.inbox.tab.updates": "Aggiornamenti",
  "social.inbox.empty.received": "Niente ti aspetta.",
  "social.inbox.empty.sent": "Non aspetti nessuno.",
  "social.inbox.empty.updates": "Ancora nessuna novità.",
  "social.inbox.friendRequest": "vuole diventare tuo amico",
  "social.inbox.groupInvite": "{name} ti invita in {group}",
  "social.inbox.groupInviteAnonymous": "Invito in {group}",
  "social.inbox.joinRequest": "vuole entrare in {group}",
  "social.inbox.sessionInvite": "{name} ti invita a {session}",
  "social.inbox.accept": "Accetta",
  "social.inbox.decline": "Rifiuta",
  "social.inbox.open": "Vedi",
  "social.inbox.cancel": "Ritira",
  "social.inbox.remind": "Ricorda",
  "social.inbox.reminded": "Ricordato",
  "social.inbox.sent.friendRequest": "Richiesta di amicizia",
  "social.inbox.sent.groupInvite": "Invitato in {group}",
  "social.inbox.links.title": "I tuoi link",
  "social.inbox.link.friend": "Link personale",
  "social.inbox.link.group": "Link per {group}",
  "social.inbox.link.ended": "Non funziona più",
  "social.inbox.link.joined": "Sono entrati: {names}",
  "social.inbox.update.friendAccepted": "{name} è ora tuo amico",
  "social.inbox.update.groupInviteAccepted": "{name} è entrato in {group}",
  "social.inbox.update.joinApproved": "Sei stato accettato in {group}",
  "social.inbox.someone": "Qualcuno",
  "social.inbox.aGroup": "un gruppo",
  "social.inbox.queued": "Parte appena torni online",
  "social.profile.title": "Profilo",
  "social.profile.lead": "Così ti vedono gli altri.",
  "social.profile.noGroups": "Non sei ancora in nessun gruppo.",
  "social.profile.signedOut": "Accedi per avere un profilo che i tuoi amici possono vedere.",
  "social.settings.title": "Impostazioni",
  "social.settings.open": "Apri le impostazioni",
  "social.notify.title": "Notifiche",
  "social.notify.invites": "Inviti e richieste",
  "social.notify.invites.hint":
    "Una notifica quando qualcuno ti invita o vuole diventare tuo amico. Chi accetta lo vedi nella posta.",
  "social.notify.quiet": "Ore di silenzio",
  "social.notify.quiet.from": "Dalle",
  "social.notify.quiet.until": "Alle",
  "social.notify.quiet.hint":
    "In queste ore niente notifiche; tutto resta comunque nella posta. Al massimo {n} notifiche al giorno.",
  "social.notify.mutes.title": "Silenziati",
  "social.notify.mutes.empty":
    "Nessuno silenziato. Un amico o un gruppo silenziato non ti manda più notifiche.",
  "social.notify.mute": "Silenzia",
  "social.notify.unmute": "Riattiva",
  "social.groups.inviteFriends": "Invita amici",
  "social.groups.inviteFriends.sent": "{n} invitati. Entrano appena accettano.",
  "social.groups.inviteLink": "Condividi un link",
  "social.groups.log.title": "Registro",
  "social.groups.log.empty": "Ancora non è successo niente.",
  "social.groups.log.created": "{name} ha creato il gruppo",
  "social.groups.log.joined": "{name} è entrato",
  "social.groups.log.left": "{name} ha lasciato il gruppo",
  "social.groups.log.removed": "{name} è stato rimosso dal gruppo",
  "social.groups.log.role": "{name} è ora {role}",
  "social.groups.mute": "Silenzia il gruppo",
  "social.groups.unmute": "Riattiva il gruppo",
  "social.share.title": "Condividi",
  "social.share.action": "Condividi",
  "social.share.shared": "Condiviso",
  "social.share.copied": "Link copiato",
  "social.invite.channel.share": "Condividi…",
  "social.inbox.link.reshare": "Condividi di nuovo",
} as const;
